///<amd-module name="typeahead/core/logging/FlightOriginPopulationLogger" />
import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {FlightOriginPopulationMetric} from "typeahead/core/logging/FlightOriginPopulationMetric";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {OriginPopulationMessage} from "typeahead/core/message/OriginPopulationMessage";
import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {Lob, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class FlightOriginPopulationLogger {

    private isAkamaiPopulated: boolean;
    private isOriginChanged: boolean;

    constructor() {
        this.isAkamaiPopulated = false;
        this.isOriginChanged = false;

        // Suggestions displayed
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(), (topic: string, message: InputValueEditedMessage) => {
                if (message.getDomElementId() && message.getDomElementId().indexOf("flight-origin") !== -1) {
                    this.isOriginChanged = true;
                }
            },
        );

        // Akamai Population
        TypeaheadMessage.subscribe(
            OriginPopulationMessage.getTopic(), (topic: string, message: OriginPopulationMessage) => {
                this.isAkamaiPopulated = true;
            },
        );

        // Wizard submitted
        TypeaheadMessage.subscribe(
            SubmitClickedMessage.getTopic(), (topic: string, message: SubmitClickedMessage) => {
                if (TypeaheadUtils.getLob() === Lob.Flight) {
                    this.emitOriginPopulationMetric();
                }
            },
        );
    }

    private emitOriginPopulationMetric(): void {
        new CollectorTransport().log(new FlightOriginPopulationMetric(
            this.isAkamaiPopulated,
            this.isOriginChanged,
        ));
    }
}
